// extracted by mini-css-extract-plugin
export default {"disclaimer__container":"SchedulesOnlineDisclaimer_disclaimer__container__YzK3w","disclaimer__text":"SchedulesOnlineDisclaimer_disclaimer__text__yqS+b"};